import React from 'react';

import ShadeSVG from './assets/shade.svg';

export const Shade = () => (
  <img src={ShadeSVG} alt="" />
);
